var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main-content" }, [
    _c(
      "div",
      { staticStyle: { margin: "10px" } },
      [
        _c(
          "el-button",
          {
            attrs: { no: "onSave", type: "success" },
            on: { click: _vm.onSave }
          },
          [_vm._v(_vm._s(_vm.$t("Pricing.Save")))]
        ),
        _c(
          "el-button",
          {
            attrs: { no: "onCancel", type: "success" },
            on: { click: _vm.onCancel }
          },
          [_vm._v(_vm._s(_vm.$t("Pricing.Cancel")))]
        )
      ],
      1
    ),
    _c("div", { staticClass: "section", staticStyle: { padding: "12px" } }, [
      _c("div", { staticStyle: { display: "flex", width: "100%" } }, [
        _c(
          "div",
          { staticClass: "form-column" },
          [
            _c(
              "el-form",
              {
                ref: "kpi",
                attrs: {
                  "label-width": "130px",
                  "label-position": "right",
                  model: _vm.kpi
                }
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("Pricing.StartTime") } },
                  [
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c("el-input-number", {
                          staticStyle: { width: "100%" },
                          attrs: { no: "starttime", max: 23, min: 0 },
                          model: {
                            value: _vm.kpi.starttime,
                            callback: function($$v) {
                              _vm.$set(_vm.kpi, "starttime", $$v)
                            },
                            expression: "kpi.starttime"
                          }
                        }),
                        _c(
                          "label",
                          { staticStyle: { "margin-left": "10px" } },
                          [_vm._v(_vm._s(_vm.$t("Pricing.Hour")))]
                        )
                      ],
                      1
                    )
                  ]
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("Pricing.EndTime") } },
                  [
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c("el-input-number", {
                          staticStyle: { width: "100%" },
                          attrs: { no: "endtime", max: 23, min: 0 },
                          model: {
                            value: _vm.kpi.endtime,
                            callback: function($$v) {
                              _vm.$set(_vm.kpi, "endtime", $$v)
                            },
                            expression: "kpi.endtime"
                          }
                        }),
                        _c(
                          "label",
                          { staticStyle: { "margin-left": "10px" } },
                          [_vm._v(_vm._s(_vm.$t("Pricing.Hour")))]
                        )
                      ],
                      1
                    )
                  ]
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("Pricing.CheckInterval") } },
                  [
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c("el-input-number", {
                          staticStyle: { width: "100%" },
                          attrs: { no: "interval", max: 23, min: 1 },
                          model: {
                            value: _vm.kpi.interval,
                            callback: function($$v) {
                              _vm.$set(_vm.kpi, "interval", $$v)
                            },
                            expression: "kpi.interval"
                          }
                        }),
                        _c(
                          "label",
                          { staticStyle: { "margin-left": "10px" } },
                          [_vm._v(_vm._s(_vm.$t("Pricing.Hour")))]
                        )
                      ],
                      1
                    )
                  ]
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("Pricing.MaxMailPerDay") } },
                  [
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c("el-input-number", {
                          staticStyle: { width: "100%" },
                          attrs: { no: "maxperday", max: 23, min: 1 },
                          model: {
                            value: _vm.kpi.maxperday,
                            callback: function($$v) {
                              _vm.$set(_vm.kpi, "maxperday", $$v)
                            },
                            expression: "kpi.maxperday"
                          }
                        }),
                        _c(
                          "label",
                          { staticStyle: { "margin-left": "10px" } },
                          [_vm._v(_vm._s(_vm.$t("Pricing.Times")))]
                        )
                      ],
                      1
                    )
                  ]
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("Pricing.KPIEmail"),
                      prop: "email",
                      rules: [
                        {
                          required: true,
                          message: _vm.$t("Price.TheEmailCannotBeEmpty")
                        },
                        {
                          type: "email",
                          message: _vm.$t("Price.EmailFormatError")
                        }
                      ]
                    }
                  },
                  [
                    _c("el-input", {
                      staticStyle: { width: "100%" },
                      attrs: { no: "email" },
                      model: {
                        value: _vm.kpi.email,
                        callback: function($$v) {
                          _vm.$set(_vm.kpi, "email", $$v)
                        },
                        expression: "kpi.email"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }